<template>
  <b-container fluid id="feature-banner" v-if="specificWebDesign">
    <b-form @submit.prevent="saveWebDesign" novalidate>
      <b-row no-gutters>
        <b-col md="8">
          <div class="main">
            <div class="toolbar">
              <div class="arrow">
                <router-link to="/design/web">
                  <img src="@/assets/images/actions/arrow-back.svg" alt />
                </router-link>
              </div>
              <div class="title">
                <b-form-group class="pt-3">
                  <b-input
                    v-model="specificWebDesign.title"
                    ref="title"
                    placeholder="Untitled"
                    required
                  ></b-input>
                </b-form-group>
              </div>
              <div class="buttons mr-3">
                <b-button
                  type="submit"
                  variant="primary"
                  class="invert mr-2"
                  @click="specificWebDesign.published = false"
                >
                  <template v-if="loading">Saving...</template>
                  <template v-else>Save Draft</template>
                </b-button>
                <b-button
                  type="submit"
                  variant="primary"
                  v-bind:disabled="loading"
                  @click="specificWebDesign.published = true"
                  class="primary"
                >
                  <template v-if="loading">Publishing...</template>
                  <template v-else>Publish</template>
                </b-button>
              </div>
            </div>
            <div class="switch-container">
              <span>Guides</span>
              <switches
                v-model="guides"
                theme="custom"
                color="primary"
                type-bold="true"
                text-enabled="On"
                text-disabled="Off"
                class="mx-3"
              ></switches>
            </div>
            <div class="screens-container">
              <div class="web my-1" style="position: relative">
                <div class="header" style="height: 60px; width: 100%">
                  <div class="logo-container">
                    <div style="position: absolute" class="guide">A</div>
                    <div v-if="logo.length == 0"
                      style="
                        width: 96px;
                        height: 40px;
                        border: 1px dashed lightgray;
                      "
                      class="upload-banner"
                    >
                    <div style="text-align:center"><b-img :src="logopreview" fluid style="height:40px" /></div>
                    </div>
                    <div v-else>
                      <img :src="logo" alt="" width="96" height="40" />
                    </div>
                  </div>
                  <div class="location-container">
                    <img src="@/assets/images/icons/ic-pin.svg" alt="" />
                    <span>Location</span>
                  </div>
                  <div class="right-container">
                    <div>
                      <img src="@/assets/images/search.svg" alt="" />
                      <span>Search</span>
                    </div>
                    <button
                      :style="{ backgroundColor: specificWebDesign.main_color, color: specificWebDesign.button_text_color }"
                      style="border: none"
                      type="button"
                      class="btn new-button btn-primary"
                    >
                      SIGN IN
                    </button>
                    <img src="@/assets/images/icons/ic-cart.svg" alt="" />
                  </div>
                </div>
                <div
                  class="banner"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 200px;
                    width: 100%;
                    background-color: #f1f1f1;
                  "
                >
                  <img
                    src="@/assets/images/image-icon.svg"
                    alt=""
                    style="display: block; margin: 30px auto"
                  />
                </div>
                <h4 style="margin-left: 25px; margin-top: 10px">
                  What's Nearby
                </h4>
                <div
                  class="footer"
                  :style="{ backgroundColor: color }"
                  style="
                    position: absolute;
                    bottom: 0;
                    height: 60px;
                    width: 100%;
                  "
                >
                  <div
                    style="
                      color: white;
                      font-size: 10px;
                      padding: 0 25px;
                      height: 60px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <div
                      style="
                        flex: 1;
                        display: flex;
                        justify-content: space-between;
                      "
                    >
                      <span>Powered by RUSH</span>
                      <span>Like us on FB</span>
                      <span>Follow us on IG</span>
                    </div>
                    <div style="flex: 1">&nbsp;</div>
                    <span>Privacy Policy | Terms of Use</span>
                  </div>
                </div>
              </div>
              <div class="web mt-4" style="position: relative">
                <div class="row">
                  <div class="col-6">
                    <div class="logo-container p-4">
                      <div style="position: absolute" class="guide">A</div>
                      <div
                        v-if="logo.length == 0"
                        style="
                          width: 96px;
                          height: 40px;
                          border: 1px dashed lightgray;
                        "
                        class="upload-banner"
                      >
                        <div style="text-align:center"><b-img :src="logopreview" fluid style="height:40px" /></div>
                      </div>
                      <div v-else>
                        <img :src="logo" alt="" width="96" height="40" />
                      </div>
                    </div>
                    <div class="container">
                      <div class="row">
                        <div class="col-12">
                          <h4 class="text-center">Log in to your account</h4>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1"></div>
                        <div class="col-10">
                          <b-form>
                            <b-form-group
                              label="Mobile Number"
                              label-for="mobile-number"
                              class="labels"
                            >
                              <b-input-group prepend="+63" class="mt-1">
                                <b-form-input
                                  id="mobile-number"
                                  required
                                  maxlength="10"
                                  disabled
                                ></b-form-input>
                                <b-input-group-append></b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                            <span style="font-size: 10px; float: right;">Forgot PIN?</span>
                            <b-form-group label="MPIN" label-for="mpin" class="labels">
                              <b-form-input disabled></b-form-input>
                            </b-form-group>
                            <b-button
                              class="btn new-button"
                              :style="{ backgroundColor: specificWebDesign.main_color, color: specificWebDesign.button_text_color }"
                              >LOG IN</b-button
                            >
                            <div class="labels mt-1">
                              Don’t have an account?
                              <span>Sign Up</span>
                            </div>
                          </b-form>
                        </div>
                        <div class="col-1"></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div style="position: absolute" class="guide m-2">C</div>
                    <div
                      class="upload-banner"
                      style="height:343px; width:333px"
                      >
                      <div style="text-align:center"><b-img :src="loginimagepreview" fluid style="height:343px; width:333px" /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="right-sidebar p-3">
            <div class="logo-section">
              <div class="label my-2" style="display: flex">
                <div class="guide">A</div>
                <span class="ml-2">LOGO</span>
              </div>
              <span  v-if="logopreview" class="previewremovelogo" v-b-modal="'delete-modal-logo'">
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" class="icon icon-remove" style="top: -7.5px; right: -5px;">
                    <path d="M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z" fill="#ff8828">
                  </path>
                  </svg>
              </span>
                <b-modal id="delete-modal-logo" title="Delete Logo Image">
                    <p class="modal-main-message">Are you sure you want delete this Logo?</p>
                    <div slot="modal-footer">
                        <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal-logo')">
                            Cancel
                        </b-btn>
                        <b-btn variant="primary" class="ml-1" @click="removeImage('logo')">
                            Yes, Delete
                        </b-btn>
                    </div>
                </b-modal>
              <div
                class="upload-banner"
                style="
                  background-repeat: no-repeat;
                  background-size: 335px 140px;
                  background-position: center;
                  text-align: center;
                "
                 v-b-modal.uploadLogo
              >
                <div><b-img :src="logopreview" fluid style="height:140px" /></div>
                <span class="img-icon">
                  <img src="@/assets/images/camera.svg" alt="Camera" />
                </span>
              </div>
              <span style="display: block">Recommended Size (185 x 60 px)</span>
              <b-modal id="uploadLogo" title="Upload Logo" no-close-on-backdrop no-close-on-esc>
                  <div id="web-logo-container" class="border mx-auto">
                      <croppa
                          v-model="myLogoCroppa"
                          @new-image-drawn="onNewLogoImage"
                          @zoom="onLogoZoom"
                          :width="335"
                          :height="140"
                          placeholder="Choose an image"
                          :show-remove-button="true"
                          :placeholder-font-size="14"
                          remove-button-color="#ff8828">
                      </croppa>
                  </div>
                  <div id="logo-image-range-container" class="mx-auto mt-2">
                      <input type="range" class="custom-range" id="customRangelogo" @input="onLogoSliderChange" :min="sliderLogoMin" :max="sliderLogoMax" step=".001" v-model="sliderLogoVal">
                  </div>
                  <div slot="modal-footer">
                      <b-button variant="secondary" @click="cancelUploadLogo" style="margin-right: .25rem;">
                          Cancel
                      </b-button>
                      <b-button variant="primary" @click="saveUploadLogo" style="margin-left: .25rem;">
                          Save
                      </b-button>
                  </div>
              </b-modal>
            </div>
            <div class="main-color-section">
              <div class="label my-2" style="display: flex">
                <div class="guide">B</div>
                <span class="ml-2">MAIN COLOR</span>
              </div>
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    id="background-color"
                    label="Button & Footer"
                    label-for="background-color"
                    class="sl-helper color-picker-container"
                    required
                  >
                    <input
                      type="color"
                      id="background-color"
                      class="color-picker"
                      v-model="specificWebDesign.main_color"
                      required
                    />
                    <img
                      style="margin-top: -35px; margin-left: 5px"
                      src="../../../assets/images/icons/colorpicker.svg"
                      alt="Color Picker"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span style="color: #979797">{{ specificWebDesign.main_color }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8">
                  <b-form-group label="Button Text" class="sl-helper">
                    <b-form-radio-group
                      id="fontColor"
                      name="fontColor"
                      v-model="specificWebDesign.button_text_color"
                    >
                      <b-form-radio value="#000000" name="text-color"
                        ><span
                          class="btn-text btn-text-2"
                          :style="'background-color: ' + specificWebDesign.main_color"
                          >Aa</span
                        ></b-form-radio
                      >
                      <b-form-radio value="#FFFFFF" name="text-color"
                        ><span
                          class="btn-text btn-text-1"
                          :style="'background-color: ' + specificWebDesign.main_color"
                          >Aa</span
                        ></b-form-radio
                      >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div class="login-image-section">
              <div class="label my-2" style="display: flex">
                <div class="guide">C</div>
                <span class="ml-2">LOGIN PAGE IMAGE</span>
              </div>
              <span  v-if="loginimagepreview" class="previewremoveLoginImage" v-b-modal="'delete-modal-login'">
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" class="icon icon-remove" style="top: -7.5px; right: -5px;">
                    <path d="M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z" fill="#ff8828">
                  </path>
                  </svg>
              </span>
                <b-modal id="delete-modal-login" title="Delete Login Image">
                    <p class="modal-main-message">Are you sure you want delete this Login Image?</p>
                    <div slot="modal-footer">
                        <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal-login')">
                            Cancel
                        </b-btn>
                        <b-btn variant="primary" class="ml-1" @click="removeImage('login')">
                            Yes, Delete
                        </b-btn>
                    </div>
                </b-modal>
                <div
                  class="upload-login-image"
                  style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                  "
                  v-b-modal.uploadLoginImage
                >
                  <div><b-img :src="loginimagepreview" fluid /></div>
                  <span class="img-icon">
                    <img src="@/assets/images/camera.svg" alt="Camera" />
                  </span>
                </div>
                <div>Recommended Size (1224 x 1080px)</div>
                <div>File size can be up to 5MB</div>
                <b-modal id="uploadLoginImage" title="Upload Login Image" no-close-on-backdrop no-close-on-esc>
                  <div id="web-login-container" class="border mx-auto">
                      <croppa
                          v-model="myLoginImageCroppa"
                          @new-image-drawn="onNewLoginImage"
                          @zoom="onLoginImageZoom"
                          :width="306"
                          :height="270"
                          placeholder="Choose an image"
                          :show-remove-button="true"
                          :placeholder-font-size="14"
                          remove-button-color="#ff8828"
                          :quality="4">
                      </croppa>
                  </div>
                  <div id="login-image-range-container" class="mx-auto mt-2">
                      <input type="range" class="custom-range" id="customRangelogo" @input="onLoginImageSliderChange" :min="sliderLoginImageMin" :max="sliderLoginImageMax" step=".001" v-model="sliderLoginImageVal">
                  </div>
                  <div slot="modal-footer">
                      <b-button variant="secondary" @click="cancelUploadLoginImage" style="margin-right: .25rem;">
                          Cancel
                      </b-button>
                      <b-button variant="primary" @click="saveUploadLoginImage" style="margin-left: .25rem;">
                          Save
                      </b-button>
                  </div>
                </b-modal>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import Switches from "vue-switches";
import { mapState } from "vuex";
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState("designs", {
      loading: state => state.loading, 
      webDesign: state => state.webDesign,
      errors: state => state.errors, 
      specificWebDesign: state => state.specificWebDesign, 
      form(state) {
          if (!this.uuid) {
              this.myLogoB64 = null;
              this.myBGB64 = null;
              return {
                  name: "Design name",
                  logo_image: null,
                  background_image: null,
                  color: "#EBECF0",
                  button_color: "#FF8828",
                  font_color: "#FFFFFF",
                  dark_mode: 0
              };
          }
          return state.details;
      },
      logopreview(state) {
          let _preview = null;

          if (this.specificWebDesign) {
              _preview = state.specificWebDesign.logo
          }

          if (this.myLogoB64) {
              _preview = "data:image/png;base64," + this.myLogoB64;
          }

          return _preview;
      },
      loginimagepreview(state) {
          let _preview = null;

          if (this.specificWebDesign) {
              _preview = state.specificWebDesign.login_image
          }

          if (this.myLoginImageB64) {
              _preview = "data:image/png;base64," + this.myLoginImageB64;
          }

          return _preview;
      },
    }),
  },
  components: {
    Switches,
  },
  created() {
    this.viewWebDesign(this.id);
  },
  data() {
    return {
      color: "#FF8828",
      guides: true,
      logo: [],
      textSelected: "#000000",
      title: null,
      loginImage: [],
      published: false,
      myLogoB64: null,
      myLogoCroppa: {},
      sliderLogoVal: 0,
      sliderLogoMin: 0,
      sliderLogoMax: 0,
      myLoginImageB64: null,
      myLoginImageCroppa: {},
      sliderLoginImageVal: 0,
      sliderLoginImageMin: 0,
      sliderLoginImageMax: 0,
    };
  },
  methods: {
    async viewWebDesign(uuid) {
      await this.$store.dispatch("designs/viewWebDesign", uuid);
    },
    inputLogo(e) {
      let files = e.target.files;
      Array.from(files).forEach((file) => this.addImage(file, "logo"));
    },
    inputLoginImage(e) {
      let files = e.target.files;
      Array.from(files).forEach((file) => this.addImage(file, "login-image"));
    },
    addImage(file, origin) {
      if (!file.type.match("image.*")) {
        alert("File not supported.");
        return;
      }
      let reader = new FileReader();

      if (origin == "logo") {
        if (this.logo) this.logo = [];
        reader.onload = (e) => this.logo.push(e.target.result);
        reader.readAsDataURL(file);
      } else if (origin == "login-image") {
        if (this.loginImage) this.loginImage = [];
        reader.onload = (e) => this.loginImage.push(e.target.result);
        reader.readAsDataURL(file);
      }
    },
    async saveWebDesign(type) {

      let logoBase64 = '';
      if (this.myLogoB64) {
          logoBase64 = this.myLogoB64;
      }

      let loginImageBase64 = '';
      if (this.myLoginImageB64) {
          loginImageBase64 = this.myLoginImageB64;
      }

      let param = {
        uuid: this.id,
        title: this.specificWebDesign.title,
        logo: logoBase64,
        main_color: this.specificWebDesign.main_color,
        button_text_color: this.specificWebDesign.button_text_color,
        login_image: loginImageBase64,
        published: this.specificWebDesign.published,
      };

      let _this = this;

      await this.$store.dispatch("designs/updateWebDesign", param).then(() => {
        if (this.errors == null) {
          _this.$router.push({ name: "web" });
        }
      });
    },

    // LOGO  CROPPA
    onLogoZoom() {
        this.sliderLogoVal = this.myLogoCroppa.scaleRatio;
    },
    onNewLogoImage() {
        this.sliderLogoVal = this.myLogoCroppa.scaleRatio;
        this.sliderLogoMin = this.myLogoCroppa.scaleRatio / 2;
        this.sliderLogoMax = this.myLogoCroppa.scaleRatio * 2;
    },
    onLogoSliderChange(evt) {
        let increment = evt.target.value;
        this.myLogoCroppa.scaleRatio = +increment;
    },
    cancelUploadLogo() {
        this.$root.$emit("bv::hide::modal", "uploadLogo");
    },
    saveUploadLogo() {
        let _base64 = this.myLogoCroppa.generateDataUrl() || null;
        if (!_base64) {
            return;
        }

        let _img64 = _base64.replace(/data:image\/png;base64,/gi, "");
        this.form.logo_image = _img64;
        this.myLogoB64 = _img64;
        this.cancelUploadLogo();
    },

    onLoginImageZoom() {
        this.sliderLoginImageVal = this.myLoginImageCroppa.scaleRatio;
    },
    onNewLoginImage() {
        this.sliderLoginImageVal = this.myLoginImageCroppa.scaleRatio;
        this.sliderLoginImageMin = this.myLoginImageCroppa.scaleRatio / 2;
        this.sliderLoginImageMax = this.myLoginImageCroppa.scaleRatio * 2;
    },
    onLoginImageSliderChange(evt) {
        let increment = evt.target.value;
        this.myLoginImageCroppa.scaleRatio = +increment;
    },
    cancelUploadLoginImage() {
        this.$root.$emit("bv::hide::modal", "uploadLoginImage");
    },
    saveUploadLoginImage() {
        let _base64 = this.myLoginImageCroppa.generateDataUrl() || null;
        if (!_base64) {
            return;
        }

        let _img64 = _base64.replace(/data:image\/png;base64,/gi, "");
        this.form.login_image = _img64;
        this.myLoginImageB64 = _img64;
        this.cancelUploadLoginImage();
    },
    removeImage(type) {
        if (type == "login") {
            this.specificWebDesign.login_image = null;
            this.form.background_image = null;
            this.myLoginImageB64 = null;
            this.myLoginImageCroppa.remove();
            this.form.color = "#EBECF0";
            this.hideModal("delete-modal-login");
        } else {
            this.specificWebDesign.logo = null;
            this.form.logo_image = null;
            this.myLogoB64 = null;
            this.myLogoCroppa.remove();
            this.hideModal("delete-modal-logo");
        }
    },
    hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
    }
  },
};
</script>

<style lang="scss" scoped>
.labels {
  font-size: 12px;
}

.btn-core {
  background-color: #FB9D50 !important;
  border-radius: 33px !important;
  color: #ffffff !important;
  font-family: sans-serif !important;
  padding: 5px 100px !important;
  border-color:  #FB9D50 !important;

  &:disabled {
    background: #d8dcde !important;
    color: #68737d !important;
  }
}

#feature-banner {
  .color-picker {
    height: 50px;
    width: 100px;
    background: none;
    border: none;
  }
  .btn-text {
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    padding: 5px;
    border: 1px solid #b8b8b8;
    background-color: #15b0db;
    border-radius: 6px;
  }

  .btn-text-1 {
    color: #fff;
  }

  .btn-text-2 {
    color: #000;
  }

  .title {
    input {
      border: none;
    }
  }

  .image-upload {
    width: 335px;
    height: 140px;
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    background-color: #ffffff
        url("../../../assets/images/achievement/default-image.svg") no-repeat
        center;
    img.image {
        width: 128px;
        height: 66px;
        border-radius: 5px;
    }

    span.img-icon {
        box-shadow: 0 0 3px #ccc, inset 0 0 3px #b8b8b8;
        padding: 2px;
        border-radius: 12.5px;
        position: absolute;
        width: 25px;
        height: 25px;
        text-align: center;
        bottom: 40px;
        left: 170px;
    }
  }
  span.previewremovelogo {
      top: 43px;
      left: 336px;
      z-index: 9;
      position: absolute;
  }

  span.previewremoveLoginImage {
    top: 470px;
    left: 337px;
    z-index: 9;
    position: absolute;
  }

  .upload-login-image {
    overflow: hidden;
    height: 296px;
  }
}

#web-logo-container {
    width: 336px;
    height: 141px;
    background-color: #f3f3f4;
    cursor: pointer;
}

#logo-image-range-container {
    width: 337px;
}

#web-login-container {
    width: 307px;
    height: 271px;
    background-color: #f3f3f4;
    cursor: pointer;
}
</style>

<style>
#web-logo-container svg.icon-remove {
  top: -160px !important;
  right: unset !important;
  left: 322px !important;
  position: relative;
}

#web-login-container svg.icon-remove {
  top: -290px !important;
  right: unset !important;
  left: 294px !important;
  position: relative;
}
</style>